export default __webpack_public_path__ + "static/media/Path2792.f79093c4.svg";